import moment from 'moment';
import * as React from 'react';
import { lazy, Suspense } from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'; 
import ILoginInfo from './Dashboard/ILoginInfo';
import './index.css';
import registerServiceWorker from './registerServiceWorker';


const pathName = window.location.pathname.toLowerCase().slice(1);

if (process.env.NODE_ENV === "production") {
	window.apihost = "/";
}

// interface IToken{
// 	UserName:string,
// 	DisplayName: string,
// 	Claims:string,
// 	Expiration:Date,
// 	RefreshToken:string,
// 	Token:string,
// 	UserRoleId:Null<string>
// }

const showLogin = (configured: boolean): boolean => {
	if (!configured) {
		window.location.href = "/setup/database";
		return true;
	}

	if (pathName !== "login") {
		return false
	};

	const Login = lazy(() => import('./Dashboard/Login'));
	ReactDOM.render(
		<Suspense fallback={<div>Loading...</div>}>
			<Login />
		</Suspense>,
		document.getElementById('root') as HTMLElement)

	return true;
}

const showMain = (configured: boolean): boolean => {
	if (!configured) {
		window.location.href = "/setup/database";
		return true;
	}

	const Main = lazy(() => import('./Dashboard/Main'));

	const itemStr = localStorage.getItem("Token")
	// if the item doesn't exist, return null
	if (!itemStr) {
		window.location.href = "/login";
		return false
	}
	const tokenStorage = JSON.parse(itemStr);
	const token = tokenStorage.value as ILoginInfo
	if (token != null) {
	const expiration = moment.utc(token.Expiration).toDate();
	const now = new Date();

	if (expiration <= now) {
	// Token expired
	localStorage.removeItem("Token");
	window.location.href = "/login";
	return false;
	}


		ReactDOM.render(
			<BrowserRouter>
				<Suspense fallback={<div>Loading...</div>}>
					<Main claims={token.Claims.split(" ")} userName={token!.UserName} displayName={token.DisplayName} />
				</Suspense>
			</BrowserRouter>,
			document.getElementById('root') as HTMLElement);
	}

	else {
		window.location.href = "/login";
	}
	return true;
}

const showSetup = (configured: boolean): boolean => {
	const paths: string[] = ["setup/email", "setup/validate", "setup/password", "setup/database"];
	if (paths.findIndex(x => pathName === x) === -1) {
		return false;
	}

	if (configured) {
		window.location.href = "/";
		return true;
	}


	const InitialSetup = lazy(() => import('./Pages/InitialSetup/InitialSetup'));
	ReactDOM.render(
		<BrowserRouter>
			<Suspense fallback={<div>Loading...</div>}>
				<InitialSetup />
			</Suspense>
		</BrowserRouter>,
		document.getElementById('root') as HTMLElement);

	return true;
}

const showMonitor = (configured: boolean): boolean => {
	if (!configured) {
		window.location.href = "/setup/database";
		return true;
	}

	if (pathName !== "monitoring") {
		return false
	};

	const Monitor = lazy(() => import('./Monitoring/MonitoringDashboard'));
	const itemStr = localStorage.getItem("Token") as Null<string>
	if (itemStr != null) {
		const tokenStorage = JSON.parse(itemStr);
		const token = tokenStorage.value as ILoginInfo

		// const arrToken = strToken.split( "." );
		// const jsonToken = Buffer.from(arrToken[1], 'base64').toString('utf8');
		// const token = JSON.parse( strToken ) as IToken;

		ReactDOM.render(
			<BrowserRouter>
				<Suspense fallback={<div>Loading...</div>}>
					<Monitor claims={token.Claims.split(" ")} />
				</Suspense>
			</BrowserRouter>,
			document.getElementById('root') as HTMLElement);

	} else {
		window.location.href = "/login";
	}

	return true;
}
const showPublic = (configured: boolean): boolean => {
	if (!configured) {
		window.location.href = "/setup/database";
		return true;
	}

	if (pathName !== "licenseagreement") {
		return false
	};
	const Agreement = lazy(() => import('./Pages/Docs/LicenseAgreement'));

	ReactDOM.render(
		<BrowserRouter>
			<Suspense fallback={<div>Loading...</div>}>
				<Agreement />
			</Suspense>
		</BrowserRouter>,
		document.getElementById('root') as HTMLElement);
	return true;
}

const checkErrorRedirect = () => {
	if (pathName === "setup/database") {
		if (showSetup(false)) {
			return false;
		}
	}
	else {
		window.location.href = "/error";
	}

	return true;
}

if (pathName === "error") {
	ReactDOM.render(
		<div>Unhandled exception error</div>,
		document.getElementById('root') as HTMLElement);
}

else {
	fetch(window.apihost + "api/AppSetting/IsConfigured")
		.then(async (resp) => {
			if (resp.ok) {
				const result = await resp.text();
				let configured = result === "true";
				if (pathName === "setup/database") {
					configured = await fetch(window.apihost + "api/AppSetting/IsValidConfigured")
						.then(async res =>
							res.text()
								.then(response => {
									if (response !== "") {
										return JSON.parse(response);
									}
								}));
				}
				//  try running all registered functions and stop
				//  whenever a function returned true.  This indicates the the 
				//  'f' in the loop already handled the request.
				[showSetup, showPublic, showMonitor, showLogin, showMain]
					.every(
						f => {
							if (f(configured)) {
								return false;
							}

							return true;
						})
			}
			else {
				return checkErrorRedirect();
			}

			return true;
		})
		.catch(ex => {
			return checkErrorRedirect();
		});

}


registerServiceWorker();
